import { useRootLoaderData } from "@made-people/gears-remix";
import { useCountriesAndLanguages } from "@made-people/grease-countries-and-languages";
import { getMultipleStoriesFromGlobalStoryblokStoriesByComponentType } from "../utils/global-story-functions";

export const useCountryContent = () => {
  const rootLoaderData = useRootLoaderData();
  const { currentCountryCode } = useCountriesAndLanguages();

  if (!currentCountryCode) return null;

  return (
    getMultipleStoriesFromGlobalStoryblokStoriesByComponentType(
      "CountryContent",
      rootLoaderData?.settingsAndContentResponse.globalStoryblokStories,
    ).find(
      (story) =>
        Array.isArray(story?.countries) &&
        story.countries.includes(currentCountryCode),
    ) ?? null
  );
};
